

import React from "react";

const Footer = () => {
  return (
    <footer className="border-t border-gray-100 py-8 px-4 bg-white">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-4">
        <div className="text-sm text-gray-500 text-center sm:text-left">
          © 2025 Abiu. All Rights Reserved
        </div>
        <div className="flex space-x-6">
          <a href="mailto:hello@abiu.earth" className="text-abiu-green hover:underline transition">hello@abiu.earth</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;